import { render, staticRenderFns } from "./SongsList.vue?vue&type=template&id=ba9fe4ba&scoped=true&"
import script from "./SongsList.vue?vue&type=script&lang=js&"
export * from "./SongsList.vue?vue&type=script&lang=js&"
import style0 from "./SongsList.vue?vue&type=style&index=0&id=ba9fe4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9fe4ba",
  null
  
)

export default component.exports